import { createApp } from 'vue'
import router from './router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { Chart, registerables } from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
import zoomPlugin from 'chartjs-plugin-zoom'
import 'chartjs-adapter-date-fns'
import '@popperjs/core'
import 'bootstrap/dist/js/bootstrap.esm'

import './bootstrap.scss'
import '@fontsource-variable/roboto/wght.css'
import '@fontsource-variable/roboto/wght-italic.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'leaflet/dist/leaflet.css'
import 'vue-select/dist/vue-select.css'
import 'flatpickr/dist/flatpickr.css'

import { setEnvironment } from './shared/system-state'
import { currentLocale, initI18n } from './i18n'
import { setAuthentication } from './api-config'
import { setupTitle } from './shared/use-title'
import { vueErrorHandler } from './shared/error-handler'
import { setupBeacon } from './shared/beacon'
import { setupIdleMeasurement } from './shared/page-session'
import './ops-log/ops-log-logic'
import { getVoice } from './shared/tts'
import { overrideValidationMessages } from './components/form-next'
import App from './App'

setAuthentication()

Chart.register(...registerables)
Chart.register(annotationPlugin)
Chart.register(zoomPlugin)

setEnvironment()
setupTitle({ suffix: 'Mathrail' })

setupIdleMeasurement()
setupBeacon()

const vueI18n = initI18n()
getVoice(currentLocale.value) // Preload voice
overrideValidationMessages(vueI18n)

const app = createApp(App)
  .use(router)
  .use(vueI18n)
  .use(VueQueryPlugin, {
    enableDevtoolsV6Plugin: true,
    queryClientConfig: {
      defaultOptions: { queries: { staleTime: 2_000 } }
    }
  })
app.mount('#app')
app.config.errorHandler = vueErrorHandler
